import React, { useEffect, useState } from 'react'
import { useParams } from 'react-router-dom'

const AzureLoginRedirect = () => {
    const [accessToken, setAccessToken] = useState('');

    useEffect(() => {
        const hash = window.location.hash;
        const params = new URLSearchParams(hash.substring(1)); // remove the '#' at the start
        const token = params.get('access_token');
        setAccessToken(token);
    }, []);

    console.log({ accessToken });

  return (
    <div>
      Redirecting...
    </div>
  )
}

export default AzureLoginRedirect
